import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Dropdown } from 'react-bootstrap';
import team1 from 'assets/img/team/1.jpg';
import Avatar from 'componentes/common/Avatar.js';
import MyModal from 'helpers/MyModal.js';
import EditPassword from 'pages/Account/_EditPassword.js';
import Divider from 'componentes/common/Divider.js';
import { useAuth } from 'context/AuthProvider.js';

const ProfileDropdown = () => {
  const [openModalPassWordChange, setOpenModalPassWordChange] = useState(false);
  const Auth = useAuth();
  var userData = Auth.getSessionData();
  function handleClose() {
    setOpenModalPassWordChange(false);
  }

  //openModalPassWordChange
  return (
    <>
      <Dropdown navbar={true} as="li">
        <Dropdown.Toggle
          bsPrefix="toggle"
          as={Link}
          to="#!"
          className="pe-0 ps-2 nav-link"
        >
          <Avatar src={team1} />
        </Dropdown.Toggle>

        <Dropdown.Menu className="dropdown-caret dropdown-menu-card  dropdown-menu-end">
          <h5
            style={{ color: 'black', textAlign: 'center' }}
            className="dropdown-header"
          >
            {userData?.user?.nombre}
          </h5>

          <Divider />
          <div className="bg-white rounded-2 py-2 dark__bg-1000">
            <Dropdown.Item
              as={Link}
              to="#"
              onClick={() => setOpenModalPassWordChange(true)}
            >
              Cambiar Contraseña
            </Dropdown.Item>
            <Dropdown.Item as={Link} to={'#'} onClick={() => Auth.logout()}>
              Cerrar Sesión
            </Dropdown.Item>
          </div>
        </Dropdown.Menu>
      </Dropdown>
      {openModalPassWordChange && (
        <MyModal
          id="id_myModal"
          title={'Modificar Contraseña'}
          openModal={openModalPassWordChange}
          closeModal={handleClose}
        >
          <EditPassword closeModal={handleClose}></EditPassword>
        </MyModal>
      )}
    </>
  );
};

export default ProfileDropdown;
